var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-block',[_c('f7-row',[_c('f7-col',{attrs:{"width":"100"}},[(!_vm.loadedTasks)?_c('f7-block',[_c('div',{staticClass:"loadingFalse"},[_c('div',{staticClass:"preloader"})])]):_c('f7-block',[_c('ListTask')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }